import { AnyStateWithSeatMap } from './types';

export const getState = (state: AnyStateWithSeatMap) => state.seatMap;
